(() => {
  const theme = window.Shopify?.theme;
  if (theme?.role !== 'unpublished' || !/^\d+$/.test(String(theme.id))) return;
  document.querySelectorAll('product-recommendations[data-url]').forEach(element => {
    const url = new URL(element.dataset.url, location.origin);
    if (url.origin !== location.origin) return;
    url.searchParams.set('preview_theme_id', String(theme.id));
    url.searchParams.set('pb', '0');
    element.dataset.url = url.pathname + url.search;
    const verify = async () => {
      if (element.querySelector('.product-item')) return;
      try {
        const response = await fetch(url.pathname + url.search);
        if (!response.ok) return;
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = document.querySelector('product-recommendations');
        if (content && !element.querySelector('.product-item')) element.innerHTML = content.innerHTML;
      } catch (_) {}
    };
    window.addEventListener('DOMContentLoaded', () => setTimeout(verify, 1000), {once: true});
  });
})();
